<template>
  <!-- Mobile menu button - positioned based on sidebar state -->
  <button
    class="mobile-menu-btn"
    :class="{ shifted: uiStore.mobileMenuOpen }"
    @click="handleMenuClick"
    aria-label="Toggle menu"
  >
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <line x1="3" y1="12" x2="21" y2="12"></line>
      <line x1="3" y1="6" x2="21" y2="6"></line>
      <line x1="3" y1="18" x2="21" y2="18"></line>
    </svg>
  </button>
  <!-- Mobile chat button - positioned based on chat panel state -->
  <button
    class="mobile-chat-btn"
    :class="{ shifted: uiStore.chatPanelOpen }"
    @click="toggleChat"
    aria-label="Toggle chat"
  >
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"></path>
    </svg>
  </button>
</template>

<script setup>
import { useUIStore } from '../stores/ui';

const uiStore = useUIStore();

const handleMenuClick = () => {
  if (uiStore.mobileMenuOpen) {
    uiStore.closeMobileMenu();
  } else {
    uiStore.openMobileMenu();
  }
};

const toggleChat = () => {
  uiStore.toggleChatPanel();
};
</script>

<style scoped>
/* Styles are in themes.css for mobile-menu-btn and mobile-chat-btn */
</style>
